import { megaMenuContent } from '../localization/en-us/megaMenuContent';

export const admin = { 
    title: megaMenuContent.admin, 
    menu:
    [ 
        {
            label:       megaMenuContent.controlPanel,
            pathName:    '/admin?company={companyId}',
            permissions: 'adminRead',
            title:       megaMenuContent.controlPanel
        },
        {
            label:       megaMenuContent.settings,
            pathName:    '/v2/dashboard/companymanagement?company={companyId}',
            permissions: 'adminRead',
            title:       megaMenuContent.settings
        },
        {
            label:       megaMenuContent.userProfile,
            pathName:    '/myaccount?company={companyId}',
            permissions: 'default',
            title:       megaMenuContent.userProfile
        },
        {
            label:       megaMenuContent.userPermission,
            pathName:    '/v2/dashboard/users?company={companyId}',
            permissions: 'default',
            title:       megaMenuContent.userPermission
        },
        {
            label:       megaMenuContent.executiveSummary,
            pathName:    '/v2/dashboard/executiveSummary?company={companyId}',
            permissions: 'default',
            title:       megaMenuContent.executiveSummary
        },
        {
            label:       megaMenuContent.equipmentAndSensor,
            pathName:    '/v2/dashboard/lookups?company={companyId}',
            permissions: 'default',
            title:       megaMenuContent.equipmentAndSensor
        },
        {
            label:       megaMenuContent.attributeManagement,
            pathName:    '/v2/dashboard/attributemanagement?company={companyId}',
            permissions: 'default',
            title:       megaMenuContent.attributeManagement
        },
        {       
            label:       megaMenuContent.announcement,
            pathName:    '/v2/dashboard/announcements?company={companyId}',
            permissions: 'default',
            title:       megaMenuContent.announcement
        },
        {
            label:       megaMenuContent.conversions,
            pathName:    '/v2/dashboard/conversions?company={companyId}',
            permissions: 'default',
            title:       megaMenuContent.conversions
        },
        /*,
        {       
            label:       megaMenuContent.customCalculations,
            pathName:    '/v2/dashboard/calculated/sensor?company={companyId}',
            permissions: 'default',
            title:       megaMenuContent.customCalculations
        }
        */
        {
            label:       megaMenuContent.roles,
            pathName:    '/v2/dashboard/roles?company={companyId}',
            permissions: 'default',
            title:       megaMenuContent.roles
        }
    ]
};

export const apps = { 
    title: megaMenuContent.apps,
    menu: 
    [
        {
            label:             megaMenuContent.serviceManagement,
            pathName:          '/servicemanagement',
            dashboardPathName: '/v2/dashboard/servicemanagement?company={companyId}',
            permissions:       'serviceManagementRead',
            title:             megaMenuContent.serviceManagement
        },
        {
            label:             megaMenuContent.reporting,
            dashboardPathName: '/v2/dashboard/reports?company={companyId}',
            permissions:       'reportsRead',
            title:             megaMenuContent.reporting
        },
        {
            label:       megaMenuContent.architect,
            pathName:    '/architect',
            permissions: 'architectRead',
            title:       megaMenuContent.architect
        },
        {
            label:       megaMenuContent.iotHub,
            pathName:    '/iothub',
            permissions: 'iothubRead',
            title:       megaMenuContent.iotHub
        },
        {
            label:             megaMenuContent.rules,
            dashboardPathName: '/v2/dashboard/rules?company={companyId}',
            permissions:       'reportsRead',
            title:             megaMenuContent.rules
        },
        {
            label:       megaMenuContent.subscriptions,
            pathName:    '/subscriptions',
            permissions: 'default',
            title:       megaMenuContent.subscriptions
        },
        {
            label:       megaMenuContent.apiDocs,
            pathName:    '/devportal/docs',
            permissions: 'default',
            title:       megaMenuContent.apiDocs
        }
    ]
};

export const company = { 
    title:        megaMenuContent.company, 
    appId:        'ad356bf2-b9db-4bb5-922e-c3394b1a63e3',
    coreAppId:    '1710345b-cf28-4a02-9bf4-df9209ff29cb',
    parentId:     'ad356bf2-b9db-4bb5-922e-c3394b1a63e4',
    coreParentId: '7e71f5d4-9fbf-4710-8601-e1f11e681479',
    menu:
    [ 
        {
            label:        megaMenuContent.client,
            pathName:     '/v2/dashboard/company?company={companyId}&appId={appId}&parentId={parentId}&childId={childId}',
            corePathName: '/v2/dashboard/core/entities?appId={appId}&company={companyId}&childId={childId}&parentId={parentId}',
            permissions:  'default',
            title:        megaMenuContent.client,
            childId:      'ccb00d85-7b0c-44ba-bd0e-db216ef1ee46',
            coreChildId:  '231b3d07-1afb-42a0-b6ff-ecb9c4dd8c48'
        },
        {
            label:        megaMenuContent.site,
            pathName:     '/v2/dashboard/company?company={companyId}&appId={appId}&parentId={parentId}&childId={childId}',
            corePathName: '/v2/dashboard/core/entities?appId={appId}&company={companyId}&childId={childId}&parentId={parentId}',
            permissions:  'default',
            title:        megaMenuContent.site,
            childId:      '181b15f1-dae9-4258-89ef-07941ff33025',
            coreChildId:  '7d2489e6-4481-481a-8fbf-d5c0262c6539'
        },
        {
            label:        megaMenuContent.equipment,
            pathName:     '/v2/dashboard/company?company={companyId}&appId={appId}&parentId={parentId}&childId={childId}',
            corePathName: '/v2/dashboard/core/entities?appId={appId}&company={companyId}&childId={childId}&parentId={parentId}',
            permissions:  'default',
            title:        megaMenuContent.equipment,
            childId:      '1593c439-3150-40b5-a5eb-1328cf5a30be',
            coreChildId:  '0da7cfdd-f757-4231-8979-7ff2b806e0a5'
        },
        {
            label:        megaMenuContent.system,
            pathName:     '/v2/dashboard/company?company={companyId}&appId={appId}&parentId={parentId}&childId={childId}',
            corePathName: '/v2/dashboard/core/entities?appId={appId}&company={companyId}&childId={childId}&client={clientId}&parentId={parentId}&site={siteId}',
            permissions:  'default',
            title:        megaMenuContent.system,
            childId:      '91475757-e1be-4bf3-a228-3be5ef997494',
            coreChildId:  'd0f113f5-32e1-4e2c-bf4d-386edb7f9bc4'
        },
        {
            label:        megaMenuContent.healthMonitor,
            pathName:     '/v2/dashboard/company?company={companyId}&appId={appId}&parentId={parentId}&childId={childId}',
            corePathName: '/v2/dashboard/core/entities?appId={appId}&company={companyId}&childId={childId}&parentId={parentId}',
            permissions:  'default',
            title:        megaMenuContent.healthMonitor,
            childId:      '82365757-e1be-4bf3-a228-3be5ef934586'
        },
        {
            label:        megaMenuContent.executiveSummary,
            pathName:     '/v2/dashboard/executivesummary?company={companyId}',
            corePathName: '/v2/dashboard/executivesummary?company={companyId}',
            permissions:  'default',
            title:        megaMenuContent.executiveSummary,
            childId:      'hags3757-e1be-4bf3-a228-3be5ef9h738d'
        }
    ]
};

export const client = { 
    title:        megaMenuContent.client, 
    appId:        'ad356bf2-b9db-4bb5-922e-c3394b1a63e3',
    coreAppId:    '1710345b-cf28-4a02-9bf4-df9209ff29cb',
    parentId:     'a73c8c70-35aa-48b7-a797-4c607ae25280',
    coreParentId: '3ee59a8f-d13a-475b-b424-ee55eef98a65',
    menu:
    [
        {
            label:        megaMenuContent.site,
            pathName:     '/v2/dashboard/client?client={clientId}&company={companyId}&appId={appId}&parentId={parentId}&childId={childId}',
            corePathName: '/v2/dashboard/core/entities?appId={appId}&company={companyId}&childId={childId}&client={clientId}&parentId={parentId}',
            permissions:  'default',
            title:        megaMenuContent.site,
            childId:      'f6ba2344-ba47-42c5-a98b-978365ca3936',
            coreChildId:  'e979b520-3695-422d-a914-ba55c51fb316'
        },
        {
            label:        megaMenuContent.equipment,
            pathName:     '/v2/dashboard/client?client={clientId}&company={companyId}&appId={appId}&parentId={parentId}&childId={childId}',
            corePathName: '/v2/dashboard/core/entities?appId={appId}&company={companyId}&childId={childId}&client={clientId}&parentId={parentId}',
            permissions:  'default',
            title:        megaMenuContent.equipment,
            childId:      '8404408d-ad6f-472e-b9dd-34383b392178',
            coreChildId:  '7e2354df-ebb5-4c68-a1a4-57cc84dd61eb'
        },
        {
            label:        megaMenuContent.system,
            pathName:     '/v2/dashboard/client?client={clientId}&company={companyId}&appId={appId}&parentId={parentId}&childId={childId}',
            corePathName: '/v2/dashboard/core/entities?appId={appId}&company={companyId}&childId={childId}&client={clientId}&parentId={parentId}&site={siteId}',
            permissions:  'default',
            title:        megaMenuContent.system,
            childId:      'e3b10bc7-eec5-45e5-8ad2-e94c8f50ca95',
            coreChildId:  'd0f113f5-32e1-4e2c-bf4d-386edb7f9bc4'
        },
        {
            label:        megaMenuContent.healthMonitor,
            pathName:     '/v2/dashboard/client?client={clientId}&company={companyId}&appId={appId}&parentId={parentId}&childId={childId}',
            corePathName: '/v2/dashboard/core/entities?appId={appId}&company={companyId}&childId={childId}&client={clientId}&parentId={parentId}',
            permissions:  'default',
            title:        megaMenuContent.healthMonitor,
            childId:      '83456757-e1be-4bf3-a228-3be5ef934586'
        }
    ]
};

export const site = { 
    title:        megaMenuContent.site, 
    appId:        'ad356bf2-b9db-4bb5-922e-c3394b1a63e3',
    coreAppId:    '1710345b-cf28-4a02-9bf4-df9209ff29cb',
    parentId:     'c0c505f5-c7fc-4317-8cb6-f6e631142a77',
    coreParentId: '33ba6af0-1e7a-4fcf-b75b-f355a01a962b',
    menu:
    [
        {
            label:        megaMenuContent.equipment,
            pathName:     '/v2/dashboard/site?client={clientId}&company={companyId}&site={siteId}&appId={appId}&parentId={parentId}&childId={childId}',
            corePathName: '/v2/dashboard/core/entities?appId={appId}&company={companyId}&childId={childId}&client={clientId}&parentId={parentId}&site={siteId}',
            permissions:  'default',
            title:        megaMenuContent.equipment,
            childId:      'bb5be75b-d466-48d5-99da-79cd66504f20',
            coreChildId:  '7035ee2f-b8ee-48ee-a9ac-ac522917dcdd'
        },
        {
            label:        megaMenuContent.system,
            pathName:     '/v2/dashboard/site?client={clientId}&company={companyId}&site={siteId}&appId={appId}&parentId={parentId}&childId={childId}',
            corePathName: '/v2/dashboard/core/entities?appId={appId}&company={companyId}&childId={childId}&client={clientId}&parentId={parentId}&site={siteId}',
            permissions:  'default',
            title:        megaMenuContent.system,
            childId:      '13dfff21-071c-4ee6-ab53-903fdcb5996a',
            coreChildId:  'd0f113f5-32e1-4e2c-bf4d-386edb7f9bc4'
        },
        {
            label:        megaMenuContent.healthMonitor,
            pathName:     '/v2/dashboard/site?client={clientId}&company={companyId}&site={siteId}&appId={appId}&parentId={parentId}&childId={childId}',
            corePathName: '/v2/dashboard/core/entities?appId={appId}&company={companyId}&childId={childId}&client={clientId}&parentId={parentId}&site={siteId}',
            permissions:  'default',
            title:        megaMenuContent.healthMonitor,
            childId:      '76543757-e1be-4bf3-a228-3be5ef934586',
        }
    ]
};

export const equipment = { 
    title:    megaMenuContent.equipment, 
    appId:    'ad356bf2-b9db-4bb5-922e-c3394b1a63e3',
    parentId: '7a88bd3d-64e3-4af9-aa06-9a31533df83c',
    menu:
    [ 
        {
            label:       megaMenuContent.sensors,
            pathName:    '/v2/dashboard/equipment?client={clientId}&company={companyId}&equipment={equipmentId}&site={siteId}&appId={appId}&parentId={parentId}&childId={childId}&viewChildId={viewChildId}',
            permissions: 'default',
            title:       megaMenuContent.sensors,
            childId:     '4b25aeb8-75d4-4522-9f77-870ab40abb07',
            viewChildId: '4b25aeb8-77d4-4522-9f77-870ab40abb07'
        },
        {
            label:       megaMenuContent.faults,
            pathName:    '/v2/dashboard/equipment?client={clientId}&company={companyId}&equipment={equipmentId}&site={siteId}&appId={appId}&parentId={parentId}&childId={childId}',
            permissions: 'default',
            title:       megaMenuContent.faults,
            childId:     'c49ee7a9-6a28-4820-967c-6c6a9652a4c8'
        },
        {
            label:       megaMenuContent.rules,
            pathName:    '/v2/dashboard/equipment?client={clientId}&company={companyId}&equipment={equipmentId}&site={siteId}&appId={appId}&parentId={parentId}&childId={childId}',
            permissions: 'default',
            title:       megaMenuContent.rules,
            childId:     '66c716c1-54ec-4b50-b6b9-9d1200ac2a78'
        },
        {
            label:       megaMenuContent.healthMonitor,
            pathName:    '/v2/dashboard/equipment?client={clientId}&company={companyId}&equipment={equipmentId}&site={siteId}&appId={appId}&parentId={parentId}&childId={childId}',
            permissions: 'default',
            title:       megaMenuContent.healthMonitor,
            childId:     '23453757-e1be-4bf3-a228-3be5ef934586'
        }
    ]
};
